import { gql, useMutation, MutationHookOptions } from "@apollo/client"

const RUN_COMPLETION_ACTIONS_QUERY = gql`
  mutation TerminationRunCompletionActions($terminationId: ID!) {
    terminationRunCompletionActions(input: { terminationId: $terminationId }) {
      errors
    }
  }
`

export const useRunTerminationCompletionAction = (options?: MutationHookOptions) =>
  useMutation(RUN_COMPLETION_ACTIONS_QUERY, options)
